/**
 * @namespace {BX.UI}
 */
export default class ProgressRoundStatus
{
	static COUNTER = "COUNTER";
	static PERCENT = "PERCENT";
	static INCIRCLE = "INCIRCLE";
	static INCIRCLECOUNTER = "INCIRCLECOUNTER";
	static NONE = "NONE";
}
